import axios from './axiosInstance';



const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};

const GetTables=({alias,dimensions}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.post(`/tables/get/${alias}`,dimensions)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const GetTable=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.get(`/tables/${_id}`)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const AddTable=({token,table}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/tables/add`,table)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const DeleteTable=({token,table}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.delete(`/tables/${table._id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}
const DeleteTables=({token,_ids}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/tables/bulkDelete`,_ids)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UnDeleteTable=({token,table_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.patch(`/tables/undelete/${table_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UnDeleteTables=({token,_ids}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.patch(`/tables/undelete/bulk`,_ids)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const UpdateTable=({token,table}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/tables/update/${table._id}`,table)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const SetTakeAwayTable=({token,_id, venue}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/tables/settakeaway/${_id}`, {venue})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}



export {
    GetTables,
    GetTable,
    AddTable,
    DeleteTable,
    DeleteTables,
    UnDeleteTable,
    UnDeleteTables,
    UpdateTable,
    SetTakeAwayTable
}


